module.exports = __webpack_public_path__ + "img/ja_portrait.49d2c466.jpeg";